export default __webpack_public_path__ + "static/media/car.773fae64.jpg";